import { calculateWeeklyPayrollTotals, calculationHourWeek, TotalHoursByDay } from '../../utils/helpers/TotalHoursFormat';
import { timeEntryTypes } from '../types/timeEntryTypes';

const initialState = {
  client: '',
  department: '',
  shift: '',
  weekday: '',
  customDate: '',
  resultBar: null,
  positionList: [],
  employeesTimeEntry: [],
  backupEmployeesTimeEntry: [],
  employeesTimeEntryDay: [],
  requestDay: [],
  absentEmployees: [],
  absentEmployeesWeek: [],
  totalWeekExcel: [],
  payrollResponse: {},
  saveTimeDayListResponse: {},
  saveTimeWeekListResponse: {},
  dateStart: '',
  dateEnd: '',
  dayResul: false,
  weekActive: true,
  positionSelectDay: ''
};

export const timeEntryReducer = (state = initialState, action) => {
  switch (action.type) {
    case timeEntryTypes.FIND_PAYROLL:
      return {
        ...state,
        payrollResponse: action.payload,
        absentEmployeesValidation: action.payload.data?.result
      };

    case timeEntryTypes.REQUEST_LIST_SAVING:
      return {
        ...state,
        requestDay: [action.payload]
      };

    case timeEntryTypes.ADD_EMPLOYEE_TIME_ENTRY:
      return {
        ...state,
        employeesTimeEntryDay:
          state.employeesTimeEntryDay && state.employeesTimeEntryDay.length === 0
            ? [action.payload]
            : [...state.employeesTimeEntryDay, action.payload]
      };

    case timeEntryTypes.ADD_EMPLOYEE_WEEK_TIME_ENTRY: {
      const { employees, date1, date2 } = action.payload;
      let weekLocked = false;
      employees.map((payroll) => {
        for (const [key, value] of Object.entries(payroll)) {
          if (key !== null) {
            if (value) {
              if (value.lockPayroll) {
                weekLocked = value.lockPayroll;
              }
            }
          }
        }
        return payroll;
      });
      let { employeesTimeEntry } = state;
      if (weekLocked) {
        employeesTimeEntry = calculateWeeklyPayrollTotals(employees, date1);
      } else {
        employeesTimeEntry = calculationHourWeek(employees, date1);
      }
      return {
        ...state,
        dateStart: date1,
        dateEnd: date2,
        employeesTimeEntry
      };
    }

    case timeEntryTypes.LOAD_VALUES_TO_EMPLOYEE_SAMETIME: {
      const { timeIn, timeOut, lunch, totalRegHour } = action.payload;
      let { employeesTimeEntryDay } = state;
      if (employeesTimeEntryDay) {
        employeesTimeEntryDay = employeesTimeEntryDay.map((employee) => {
          const employeeCopy = { ...employee };
          if (!employeeCopy.lockPayroll) {
            employeeCopy.timeIn = timeIn;
            employeeCopy.timeOut = timeOut;
            employeeCopy.lunch = lunch;
            if (totalRegHour !== undefined) {
              employeeCopy.totalRegHour = parseFloat(totalRegHour);
            } else {
              employeeCopy.totalRegHour = 0;
            }
          }
          return employeeCopy;
        });
      }
      return {
        ...state,
        employeesTimeEntryDay
      };
    }

    case timeEntryTypes.LOAD_VALUES_TO_EMPLOYEE_SAMETIME_WEEK: {
      const { employeesTimeEntry, dateStart } = state;
      const regHours = parseFloat(action.payload);
      if (employeesTimeEntry) {
        const updatedEmployeesTimeEntry = employeesTimeEntry.map((employee) => {
          const employeeCopy = { ...employee };
          for (const [key, value] of Object.entries(employeeCopy)) {
            if (value && typeof value === 'object' && value.totalRegHour !== undefined) {
              if (!value.lockPayroll) {
                employeeCopy[key] = {
                  ...value,
                  totalRegHour: regHours,
                  totalOtHour: 0
                };
              }
            }
          }
          return employeeCopy;
        });
        const calculatedEmployees = calculationHourWeek(updatedEmployeesTimeEntry, dateStart);
        return {
          ...state,
          employeesTimeEntry: calculatedEmployees
        };
      }
      return state;
    }

    case timeEntryTypes.MOVE_EMPLOYEE_TO_ABSENTS_TABLE: {
      const exist = state.absentEmployees.find((item) => item.payrollId === action.payload.payrollId);
      if (exist) return { ...state };
      let { absentEmployees } = state;
      absentEmployees = [...state.absentEmployees, action.payload];
      absentEmployees.map((employee) => {
        employee.timeIn = 0;
        employee.timeOut = 0;
        employee.lunch = 0;
        employee.totalRegHour = 0;
        employee.totalOtHour = 0;
        return employee;
      });
      return {
        ...state,
        employeesTimeEntryDay: state.employeesTimeEntryDay.filter((employee) => employee.payrollId !== action.payload.payrollId),
        absentEmployees
      };
    }

    case timeEntryTypes.MOVE_EMPLOYEE_TO_TIME_ENTRY_TABLE: {
      return {
        ...state,
        absentEmployees: state.absentEmployees.filter((employee) => employee.payrollId !== action.payload.payrollId),
        employeesTimeEntryDay: [...state.employeesTimeEntryDay, action.payload]
      };
    }

    // TODO: rename action - used for Excel hours data
    case timeEntryTypes.MOVE_EMPLOYEE_TO_ABSENTS_WEEK_TABLE:
      return {
        ...state,
        absentEmployeesWeek: action.payload
      };

    case timeEntryTypes.CHANGE_TIME_ENTRY_VALUE: {
      const { payrollId, key, value } = action.payload;
      const { employeesTimeEntryDay } = state;
      const updatedEmployees = employeesTimeEntryDay.map((employee) => {
        if (employee.payrollId === payrollId) {
          if (key === 'totalRegHour') {
            return { ...employee, totalRegHour: value };
          } else {
            const updatedEmployee = { ...employee, [key]: value };

            if (['timeIn', 'timeOut', 'lunch'].includes(key)) {
              if (updatedEmployee.timeIn && updatedEmployee.timeOut && updatedEmployee.lunch !== undefined) {
                updatedEmployee.totalRegHour = TotalHoursByDay(updatedEmployee.timeIn, updatedEmployee.timeOut, updatedEmployee.lunch);
              }
            }
            return updatedEmployee;
          }
        }
        return employee;
      });
      return {
        ...state,
        employeesTimeEntryDay: updatedEmployees
      };
    }

    case timeEntryTypes.CHANGE_WEEK_TIME_ENTRY_VALUE: {
      const { id, day, key, value } = action.payload;
      const { employeesTimeEntry, dateStart } = state;
      if (employeesTimeEntry) {
        const numValue = Number(value);
        const safeValue = Number.isFinite(numValue) ? numValue : 0;
        const updatedEmployeesTimeEntry = employeesTimeEntry.map((employee) => {
          if (employee.id === id && employee[day]) {
            const employeeCopy = { ...employee };
            employeeCopy[day] = {
              ...employee[day],
              [key]: safeValue
            };
            return employeeCopy;
          }
          return employee;
        });
        const calculatedEmployees = calculationHourWeek(updatedEmployeesTimeEntry, dateStart);
        return {
          ...state,
          employeesTimeEntry: calculatedEmployees
        };
      }
      return state;
    }

    case timeEntryTypes.CHANGE_WEEK_TIME_ENTRY_VALUE_LOCKED: {
      const { payrollId, day, key, value, positionId } = action.payload;
      const { employeesTimeEntry, dateStart } = state;
      if (employeesTimeEntry) {
        const updatedEmployeesTimeEntry = employeesTimeEntry.map((employee) => {
          if (employee?.payrollId === payrollId && employee?.position?.positionId === positionId && employee[day]) {
            const employeeCopy = { ...employee };
            employeeCopy[day] = {
              ...employee[day],
              [key]: parseFloat(value)
            };
            return employeeCopy;
          }
          return employee;
        });
        const calculatedEmployees = calculateWeeklyPayrollTotals(updatedEmployeesTimeEntry, dateStart);
        return {
          ...state,
          employeesTimeEntry: calculatedEmployees
        };
      }
      return state;
    }

    case timeEntryTypes.CHANGE_STATE: {
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    }

    case timeEntryTypes.FIND_WEEK_ACTIVE: {
      return {
        ...state,
        weekActive: action.payload
      };
    }

    case timeEntryTypes.RESET_ENTIRE_STATE:
      return initialState;

    case timeEntryTypes.TIMEDAY_LIST_SAVING:
      return {
        ...state,
        saveTimeDayListResponse: action.payload
      };

    case timeEntryTypes.TIMEWEEK_LIST_SAVING:
      return {
        ...state,
        saveTimeWeekListResponse: action.payload
      };

    case timeEntryTypes.TOTALS_WEEK_EXCEL:
      return {
        ...state,
        totalWeekExcel: action.payload
      };

    case timeEntryTypes.SET_FIND_BY_WEEK:
      return {
        ...state,
        isFindByWeek: action.payload
      };

    case timeEntryTypes.CLEAR_PROP: {
      return {
        ...state,
        employeesTimeEntry: [],
        employeesTimeEntryDay: [],
        absentEmployees: [],
        dayResul: false,
        weekDay: ''
      };
    }
    case timeEntryTypes.UPDATE_WEEK_PAYROLL: {
      const { id, weekData } = action.payload;

      return {
        ...state,
        employeesTimeEntry: state.employeesTimeEntry.map((entry) => (entry.id === id ? { ...entry, ...weekData } : entry))
      };
    }

    case timeEntryTypes.BACKUP_WEEK_PAYROLL:
      return {
        ...state,
        backupEmployeesTimeEntry: [...state.employeesTimeEntry]
      };

    case timeEntryTypes.RESTORE_WEEK_PAYROLL:
      return {
        ...state,
        employeesTimeEntry: state.backupEmployeesTimeEntry || state.employeesTimeEntry
      };

    case timeEntryTypes.CHANGE_WEEK_POSITION: {
      const { id, position } = action.payload;
      const { employeesTimeEntry } = state;
      if (employeesTimeEntry) {
        const updatedEmployeesTimeEntry = employeesTimeEntry.map((employee) => {
          if (employee.id === id) {
            const employeeCopy = { ...employee };

            employeeCopy.position = {
              positionId: position.positionId,
              name: position.name || position.positionName,
              positionName: position.positionName || position.name,
              departmentId: position.departmentId,
              departmentName: position.departmentName
            };

            if (position.departmentId) {
              employeeCopy.department = {
                departmentId: position.departmentId,
                name: position.departmentName || employeeCopy.department?.name
              };
            }

            const daysOfWeek = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
            daysOfWeek.forEach((day) => {
              if (employeeCopy[day]) {
                employeeCopy[day] = {
                  ...employeeCopy[day],
                  position: {
                    positionId: position.positionId,
                    name: position.name || position.positionName,
                    positionName: position.positionName || position.name,
                    departmentId: position.departmentId,
                    departmentName: position.departmentName
                  },
                  department: position.departmentId
                    ? {
                        departmentId: position.departmentId,
                        name: position.departmentName || employeeCopy[day]?.department?.name
                      }
                    : employeeCopy[day]?.department
                };
              }
            });

            return employeeCopy;
          }
          return employee;
        });
        return {
          ...state,
          employeesTimeEntry: updatedEmployeesTimeEntry
        };
      }
      return state;
    }

    case timeEntryTypes.CHANGE_DAY_POSITION: {
      const { id, position, day, payrollId } = action.payload;
      const { employeesTimeEntry, dateStart } = state;
      if (employeesTimeEntry) {
        const updatedEmployeesTimeEntry = employeesTimeEntry.map((employee) => {
          if (employee.id === id && employee[day]?.payrollId === payrollId) {
            const employeeCopy = { ...employee };

            if (employeeCopy[day]) {
              employeeCopy[day] = {
                ...employeeCopy[day],
                position: {
                  positionId: position.positionId,
                  name: position.name || position.positionName,
                  positionName: position.positionName || position.name,
                  departmentId: position.departmentId,
                  departmentName: position.departmentName
                },
                department: position.departmentId
                  ? {
                      departmentId: position.departmentId,
                      name: position.departmentName || employeeCopy[day]?.department?.name
                    }
                  : employeeCopy[day]?.department
              };
            }

            return employeeCopy;
          }
          return employee;
        });
        const calculatedEmployees = calculationHourWeek(updatedEmployeesTimeEntry, dateStart);
        return {
          ...state,
          employeesTimeEntry: calculatedEmployees
        };
      }
      return state;
    }

    default:
      return state;
  }
};
